import React from "react";
import TransferTable from "./Transfertable";

const TextTransfer = ({ rows = [], loadingData = false, error = "" }) => (
    <TransferTable
        rows={rows}
        loadingData={loadingData}
        error={error}
        channel="Texts"
    />
);

export default TextTransfer;